import * as Sentry from '@sentry/react';

import { isSentryInitialized } from '@/config/sentry';

import type { Logger, LogContext } from './types';

/**
 * Forwards warn/error to Sentry when initialized.
 */
class SentryLogger implements Logger {
  debug(_message: string, _context?: LogContext): void {
    // Debug stays local only
  }

  info(_message: string, _context?: LogContext): void {
    // Info stays local only (console); avoid noisy/expensive Sentry captureMessage volume.
  }

  warn(message: string, context?: LogContext): void {
    if (!isSentryInitialized()) {
      return;
    }
    Sentry.captureMessage(message, { level: 'warning', extra: context });
  }

  error(message: string, error?: Error, context?: LogContext): void {
    if (!isSentryInitialized()) {
      return;
    }
    if (error) {
      Sentry.captureException(error, { extra: { message, ...context } });
    } else {
      Sentry.captureMessage(message, { level: 'error', extra: context });
    }
  }
}

export const sentryLogger = new SentryLogger();
